import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { ToastService } from 'ng-uikit-pro-standard';
import { CustomerService } from 'src/app/services/customer.service';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { NewCustomerComponent } from '../../employee-activities/forms/new-customer/new-customer.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-new-sales-round',
  templateUrl: './new-sales-round.component.html',
  styleUrls: ['./new-sales-round.component.scss']
})
export class NewSalesRoundComponent implements OnInit {

  // botones round
  // cancelButtonround: any;
  // saveButtonRound: any;

  _projectid;
  @Input('projectid')
  set projectid(projectid: any) {
    this._projectid = projectid;
    this.initFormProjectRound();
    // if (projectid && projectid.projectidid > 0)
    // this.setprojectidInfo(projectid);
  }

  get projectid(): any { return this._projectid; }


  @Input() popupNewRound = false;

  @Output() onInsertUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseModal: EventEmitter<any> = new EventEmitter<any>();

  _formProjectRound: FormGroup;

  saveEditButtonround: any;
  cancelButtonround: any;

  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;
  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  popupCustomer:boolean=false
  customerDataSource: DataSource;

  addProdSpeButtonNOTBIDREASON:any
  popupaddProdSpeButtonNOTBIDREASON:boolean=false

  constructor(private toast: ToastService,
    private salesProjectService: SalesProjectService,
    private customerService: CustomerService,
    private translate:TranslateService) {
     // botones new round
      // this.cancelButtonround = {
      //   text: this.translate.instant('btnCancel'),
      //   elementAttr: {
      //     id: 'bton-gray'
      //   },
      //   onClick: () => {
      //     this.popupNewRound = false
      //   },
      // };


      // this.saveButtonRound = {
      //   text: this.translate.instant('btnSave'),
      //   icon: 'check',
      //   elementAttr: {
      //     id: 'bton-green'
      //   },
      //   onClick: () => {
      //     this.saveProjectRound()
      //   },
      // };


    }

  ngOnInit() {
    this.initFormProjectRound();

    let mythis = this;
    this.customerDataSource = new DataSource({
      load: function (loadOptions: any) { 
        return mythis.customerService.GetCustomerCEByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log('DATA ', data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });



    this.addProdSpeButtonNOTBIDREASON = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer = true;
      },
    };


    this.cancelButtonNewCustomer = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupCustomer = false;
      },
    };

    this.saveButtonNewCustomer = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
    };

    this.cancelButtonround = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.popupNewRound = false;
      },
    };


    this.saveEditButtonround = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveProjectRound()
      },
      // disabled: this._formProjectRound.invalid
    };
  }

  onHidden() {
    this.onCloseModal.emit();
  }

  initFormProjectRound() {
    this._formProjectRound = new FormGroup({
      bidnotes: new FormControl({ value: '', disabled: false }, []),
      customerid: new FormControl({ value: null, disabled: false }, [Validators.required]),
      round6: new FormControl({ value: 0, disabled: false }, []),
      round5: new FormControl({ value: 0, disabled: false }, []),
      round4: new FormControl({ value: 0, disabled: false }, []),
      round3: new FormControl({ value: 0, disabled: false }, []),
      round2: new FormControl({ value: 0, disabled: false }, []),
      round1: new FormControl({ value: 0, disabled: false }, []),
      round0: new FormControl({ value: 0, disabled: false }, []),
      projectid: new FormControl({ value: this._projectid, disabled: false }, []),
      id: new FormControl({ value: 0, disabled: false }, []),
      customername: new FormControl({ value: '', disabled: false }, []),

    });
  }

  setFormProjectRound(val) {
    console.log(val)
    this._formProjectRound = new FormGroup({
      bidnotes: new FormControl({ value: val.BIDNOTES, disabled: false }, []),
      customerid: new FormControl({ value: val.CustomerID, disabled: false }, [Validators.required]),
      round6: new FormControl({ value: val.ROUND6, disabled: false }, []),
      round5: new FormControl({ value: val.ROUND5, disabled: false }, []),
      round4: new FormControl({ value: val.ROUND4, disabled: false }, []),
      round3: new FormControl({ value: val.ROUND3, disabled: false }, []),
      round2: new FormControl({ value: val.ROUND2, disabled: false }, []),
      round1: new FormControl({ value: 0, disabled: false }, []),
      round0: new FormControl({ value: val.ROUND0, disabled: false }, []),
      projectid: new FormControl({ value: this._projectid, disabled: false }, []),
      id: new FormControl({ value: val.ID, disabled: false }, []),
      customername: new FormControl({ value: val.CUSTOMERNAME, disabled: false }, []),
    });
  }



  saveProjectRound() {
    let value = this._formProjectRound.value;


    value.round0 = !value.round0 ? 0 : value.round0;
    value.round1 = !value.round1 ? 0 : value.round1;
    value.round2 = !value.round2 ? 0 : value.round2;
    value.round3 = !value.round3 ? 0 : value.round3;
    value.round4 = !value.round4 ? 0 : value.round4;
    value.round5 = !value.round5 ? 0 : value.round5;
    value.round6 = !value.round6 ? 0 : value.round6;

    console.log(JSON.stringify(value));
    console.log(this._projectid)
    this.salesProjectService.InsertUpdateProjectRound(value).subscribe(result => {
      this.toast.success(this.translate.instant('msgProjRoun'));
      // this.getProjectRound();
      this.onInsertUpdate.emit();
      this.onCloseModal.emit();
      this.popupNewRound = false;
    })
  }

  updateCustomerProjectRound(item) {
    if(item != undefined){
      if(item.selectedItem != undefined){
        if (item.selectedItem.ID) {
          this._formProjectRound.get('customerid').setValue(item.selectedItem.ID);
          // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
        }
      }
    }
  }

  resultulCustumerOriginal(ev) {
    console.log(ev);

    let obj = {
      selectedItem: {
        ID: ev.id,
        DESCRIPTION: ev.name
      }
    };

    this._formProjectRound.get('customerid').setValue(ev.id);
    this._formProjectRound.get("customername").setValue(ev.name)
  }


}
